import { IPaginationParams } from 'services/types';
import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../DefaultService';

import {
  ISchoolShiftCreateParams,
  ISchoolShiftFilterParams,
  ISchoolShiftProps,
  ISchoolShiftSimpleProps,
  ISchoolShiftUpdateParams,
} from './types';

const ENDPOINT = 'v1/schoolShift';

/**
 * Wrapper genérico para centralizar o try/catch, o retorno do .data 
 * e a formatação do erro, eliminando a repetição de código.
 */
const fetchData = async <T>(promise: Promise<import('axios').AxiosResponse<T>>): Promise<T> => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw new Error(toUserMessage(error));
  }
};

export const createSchoolShiftAsync = ({ data }: ISchoolShiftCreateParams): Promise<ISchoolShiftProps> => {
  return fetchData(api.post(ENDPOINT, data));
};

export const getSchoolShiftByIdAsync = (id: number): Promise<ISchoolShiftProps> => {
  return fetchData(api.get(`${ENDPOINT}/${id}`));
};

export const getAllSchoolShiftByLicenseAsync = (
  pagination?: IPaginationParams,
  filter?: ISchoolShiftFilterParams,
): Promise<ISchoolShiftSimpleProps[]> => {
  return fetchData(api.get(`${ENDPOINT}/getAllByLicense`, { params: { ...pagination, ...filter } }));
};

export const getAllSchoolShiftCountAsync = (filter?: ISchoolShiftFilterParams): Promise<number> => {
  return fetchData(api.get(`${ENDPOINT}/getAllByLicense/count`, { params: { ...filter } }));
};

export const updateSchoolShiftAsync = ({ id, data }: ISchoolShiftUpdateParams): Promise<ISchoolShiftProps> => {
  return fetchData(api.put(`${ENDPOINT}/${id}`, data));
};

export const deleteSchoolShiftAsync = (id: number): Promise<void> => {
  return fetchData(api.delete(`${ENDPOINT}/${id}`));
};